import { Icons } from '..';
import calendar from './icons/calendar.svg';
import engineSimple from './icons/engineSimple.svg';
import correct from './icons/correct.svg';
import logo from './icons/logo.svg';
import info from './icons/info.svg';
import basket from './icons/basketOutline.svg';
import account from './icons/loginIcon.svg';
import car from './icons/car.svg';
import carStore from './icons/carStore.svg';
import mail from './icons/mail.svg';
import edit from './icons/edit.svg';
import dealer from './icons/dealer.svg';
import securePayent from './icons/securePayment.svg';
import squarePlus from './icons/squarePlus.svg';
import infoCircle from './icons/infoCircle.svg';
import manual from './icons/manual.svg';
import fuel from './icons/fuel.svg';
import clockBlack from './icons/IconClockBlack.svg';
import error from './icons/error.svg';
import contactPhone from './icons/phoneIcon.svg';
import Folder from './icons/folder.svg';
import PoiCommercialBuilding from './icons/poiCommercialBuilding.svg';
import PlusIcon from './icons/plus.svg';

export const iconsOV = (name: Icons) => {
    switch (name) {
        case Icons.Logo:
            return logo;
        case Icons.Account:
            return account;
        case Icons.Basket:
            return basket;
        case Icons.Calendar:
            return calendar;
        case Icons.EngineSimple:
            return engineSimple;
        case Icons.Info:
            return info;
        case Icons.Phone:
            return contactPhone;
        case Icons.Car:
            return car;
        case Icons.CarStore:
            return carStore;
        case Icons.SecurePayment:
            return securePayent;
        case Icons.Correct:
            return correct;
        case Icons.SquarePlus:
            return squarePlus;
        case Icons.InfoCircle:
            return infoCircle;
        case Icons.Dealer:
            return dealer;
        case Icons.Manual:
            return manual;
        case Icons.Mail:
            return mail;
        case Icons.edit:
            return edit;
        case Icons.Fuel:
            return fuel;
        case Icons.Clock:
            return clockBlack;
        case Icons.Folder:
            return Folder;
        case Icons.Alert:
            return error;
        case Icons.PoiCommercialBuilding:
            return PoiCommercialBuilding;
        case Icons.PlusIcon:
            return PlusIcon;
        default:
            return '';
    }
};
